/**
 * Whether a module row's Assign (+) and Unlink actions are available. Everything is staged
 * locally until Save (see `useStagedPhaseModules`), so "assigned to this phase" is always read
 * from the locally staged ids, in both create and edit mode; "assigned elsewhere" compares the
 * module's server-wide placement (`module.currentStudyPathId`) against this phase's id, which
 * also correctly flags it in create mode (no real `phaseId` yet, so any existing placement
 * counts as elsewhere) — this is what keeps a module already placed in another, already-saved
 * phase from being assignable into a new one.
 * @param {object} module Module row being checked, needing `Id`/`currentStudyPathId`.
 * @param {number} [phaseId] This phase's id; falsy in create mode.
 * @param {number[]} stagedModuleIds Ids currently staged for this phase.
 */
export function getModuleAssignmentPermissions(module, { phaseId, stagedModuleIds }) {
    const isAssignedToThisPhase = stagedModuleIds.includes(module.Id);
    const isAssignedElsewhere = Boolean(module.currentStudyPathId) && module.currentStudyPathId !== Number(phaseId);

    return {
        canAssign: !isAssignedToThisPhase && !isAssignedElsewhere,
        assignDisabledReason: isAssignedToThisPhase
            ? "Already added to this phase."
            : isAssignedElsewhere ? `Already placed in ${module.currentStudyPath}.` : null,
        canUnlink: isAssignedToThisPhase,
        unlinkDisabledReason: isAssignedToThisPhase ? null : "Not currently assigned to this phase.",
    };
}
